import React, { useEffect, useRef, useState } from 'react';

const ParallaxHeader = () => {
  const [appear, setAppear] = useState(false);
  const layersRef = useRef([]);

  useEffect(() => {
    const timer = setTimeout(() => setAppear(true), 200);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      var scrollTop = window.scrollY;

      layersRef.current.forEach(function(layer) {
        if (!layer) return;

        var dataSpeed = layer.getAttribute('data-speed');
        var offsetY = -(scrollTop * dataSpeed);
        var translate = 'translate3d(0, ' + offsetY + 'px, 0)';

        layer.style.webkitTransform = translate;
        layer.style.mozTransform = translate;
        layer.style.msTransform = translate;
        layer.style.oTransform = translate;
        layer.style.transform = translate;
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header>
      <div className="parallax desktop">
        <div
          ref={el => layersRef.current[0] = el}
          className="layer parallax-layer"
          data-speed="-0.7"
          style={{
            background: "url('/assets/img/landscape_background.png') center center / cover",
          }}
        />
        <div
          ref={el => layersRef.current[1] = el}
          className={`layer parallax-layer fade-in${appear ? ' appear' : ''}`}
          data-speed="-0.5"
          style={{
            background: "url('/assets/img/landscape.png') center center / cover",
          }}
        />
        <div
          ref={el => layersRef.current[2] = el}
          className="layer parallax-layer"
          data-speed="-0.2"
          style={{
            background: "url('/assets/img/landscape_mountain.png') center center / cover",
          }}
        />
      </div>

      <div className="bottom-fade" />

      <div className="right-bottom-text">
        <span>Game Developer</span>
      </div>
    </header>
  );
};

export default ParallaxHeader;